import Vue from 'vue';
export default Vue.extend({
    name: 'orangeLoanCredit',
    data: function () {
        return {
            active: 0,
            creditStatus: 1,
        };
    },
    created: function () {
        this.creditStatus = this.$route.query.status;
        this.$router.push({ name: 'orangeLoanCreditApply' });
        if (this.creditStatus === 0 || !this.creditStatus) {
            this.$router.push({ name: 'orangeLoanCreditApply' });
        }
        else {
            this.$router.push({
                name: 'orangeLoanCreditStatus',
                query: { status: this.creditStatus },
            });
        }
    },
    methods: {
        getCreditStatus: function (statusObj) {
            this.status = statusObj.creditStatus;
            this.active = statusObj.stepStatus;
        },
    },
});
